import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import { doc, getDoc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../lib/firebase';

interface ViewCounterProps {
  treeId: string;
}

export default function ViewCounter({ treeId }: ViewCounterProps) {
  const [views, setViews] = useState(0);

  useEffect(() => {
    const updateViews = async () => {
      const viewsKey = `tree_views_${treeId}`;
      const lastView = localStorage.getItem(viewsKey);
      const now = Date.now();

      // Solo contar vista si han pasado más de 1 hora
      if (!lastView || now - parseInt(lastView) > 3600000) {
        try {
          const treeRef = doc(db, 'trees', treeId);
          const treeDoc = await getDoc(treeRef);
          
          if (treeDoc.exists()) {
            const currentViews = treeDoc.data().views || 0;
            await updateDoc(treeRef, {
              views: increment(1)
            });
            setViews(currentViews + 1);
            localStorage.setItem(viewsKey, now.toString());
          }
        } catch (error) {
          console.error('Error updating views:', error);
        }
      } else {
        // Mostrar las vistas actuales sin incrementar
        const treeRef = doc(db, 'trees', treeId);
        const treeDoc = await getDoc(treeRef);
        if (treeDoc.exists()) {
          setViews(treeDoc.data().views || 0);
        }
      }
    };

    updateViews();
  }, [treeId]);

  return (
    <div className="flex items-center text-gray-600">
      <Eye className="h-4 w-4 mr-1" />
      <span className="text-sm">{views.toLocaleString()} visualizaciones</span>
    </div>
  );
}